import React from 'react';

const ErrorModal = ({ open, title, message, onClose }) => {
  if (!open) return null;
  return (
    <div
      className="error-modal"
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}
    >
      <div
        className="error-modal__content"
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'relative', width: 'min(560px, 92vw)', background: '#0b1220', border: '1px solid #334155', borderRadius: 12, boxShadow: '0 12px 30px rgba(0,0,0,0.5)' }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px', borderBottom: '1px solid #1f2531' }}>
          <div style={{ width: 28, height: 28, borderRadius: 8, background: 'rgba(239,68,68,0.18)', border: '1px solid rgba(239,68,68,0.5)', display: 'grid', placeItems: 'center', color: '#ef4444', fontWeight: 800 }}>!</div>
          <div style={{ fontWeight: 700, color: '#e5e7eb' }}>{title}</div>
          <button onClick={onClose} style={{ marginLeft: 'auto', width: 32, height: 32, borderRadius: 8, border: '1px solid #334155', background: '#1f2937', color: '#e5e7eb', display: 'grid', placeItems: 'center' }}>×</button>
        </div>
        <div style={{ padding: '16px', color: '#cbd5e1', lineHeight: 1.6 }}>{message}</div>
        <div style={{ padding: '12px 16px', borderTop: '1px solid #1f2531', display: 'flex', justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '8px 12px', borderRadius: 8, background: '#10b981', color: '#06251f', fontWeight: 700, border: 'none' }}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
